import { render, staticRenderFns } from "./_template-uploaded-files.vue?vue&type=template&id=bc544126&scoped=true&"
import script from "./_template-uploaded-files.vue?vue&type=script&lang=js&"
export * from "./_template-uploaded-files.vue?vue&type=script&lang=js&"
import style0 from "./_template-uploaded-files.vue?vue&type=style&index=0&id=bc544126&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc544126",
  null
  
)

export default component.exports